import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _aggregation = {
    range: '_rangeAggregation',
    nested: '_nestedAggregation',
};
var _aggregationData = { results: '_aggregationResults' };
var _aggregationResults = {
    ranges: '_rangeResults',
    scalar: '_aggregationResultsScalarResult',
    groupedByValue: '_groupByValueResults',
    nested: '_nestedResults',
};
var _aggregationResultsScalarResult = { value: 'DOUBLE' };
var _analyticsItem = { chart: '_analyticsValue' };
var _analyticsValue = { label: 'google.protobuf.Timestamp' };
var _bulkCreateProjectsRequest = { projects: '_project' };
var _bulkCreateProjectsResponse = { results: '_bulkProjectResult' };
var _bulkDeleteProjectsRequest = {};
var _bulkDeleteProjectsResponse = {};
var _bulkGetAnalyticsRequest = {};
var _bulkGetAnalyticsResponse = {
    projectsAnalytics: '_getAnalyticsResponse',
};
var _bulkProjectResult = { item: '_project' };
var _bulkUpdateProjectsRequest = { projects: '_maskedProject' };
var _bulkUpdateProjectsResponse = {
    results: '_bulkUpdateProjectsResponseBulkProjectResult',
};
var _bulkUpdateProjectsResponseBulkProjectResult = { item: '_project' };
var _bulkUpdateProjectTagsByFilterRequest = {};
var _bulkUpdateProjectTagsByFilterResponse = {};
var _bulkUpdateProjectTagsRequest = {};
var _bulkUpdateProjectTagsResponse = {};
var _createProjectFromBriefRequest = { briefFile: 'BYTES' };
var _createProjectFromBriefResponse = { project: '_project' };
var _createProjectFromScratchRequest = {};
var _createProjectFromScratchResponse = { project: '_project' };
var _createProjectRequest = { project: '_project' };
var _createProjectResponse = { project: '_project' };
var _cursorSearch = { aggregations: '_aggregation' };
var _deleteProjectRequest = {};
var _deleteProjectResponse = {};
var _extractProjectFromBriefRequest = {
    briefFile: 'google.protobuf.BytesValue',
};
var _extractProjectFromBriefResponse = { project: '_project' };
var _generateProjectAndAssetsRequest = { briefFile: 'BYTES' };
var _generateProjectAndAssetsResponse = { project: '_project' };
var _getAnalyticsRequest = {};
var _getAnalyticsResponse = { analyticsItems: '_analyticsItem' };
var _getAutomationsRequest = {};
var _getAutomationsResponse = {};
var _getBriefRequest = {};
var _getBriefResponse = {};
var _getMainUrlRequest = {};
var _getMainUrlResponse = {};
var _getProjectRequest = {};
var _getProjectResponse = { project: '_project' };
var _getRecommendedAssetTypesRequest = {};
var _getRecommendedAssetTypesResponse = {};
var _groupByValueResults = { results: '_nestedValueAggregationResult' };
var _listAllAppsInProjectRequest = {};
var _listAllAppsInProjectResponse = {};
var _maskedProject = {
    fieldMask: 'google.protobuf.FieldMask',
    project: '_project',
};
var _nestedAggregation = { nestedAggregations: '_nestedAggregationItem' };
var _nestedAggregationItem = { range: '_rangeAggregation' };
var _nestedAggregationResults = {
    ranges: '_rangeResults',
    scalar: '_aggregationResultsScalarResult',
};
var _nestedResults = { results: '_results' };
var _nestedResultValue = { range: '_rangeResult', scalar: '_scalarResult' };
var _nestedValueAggregationResult = {
    nestedResults: '_nestedAggregationResults',
};
var _project = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    timeline: '_timeline',
};
var _queryProjectsRequest = {};
var _queryProjectsResponse = { projects: '_project' };
var _rangeAggregation = { buckets: '_rangeBucket' };
var _rangeAggregationResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeBucket = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResults = { results: '_rangeAggregationResult' };
var _results = { results: 'Map#_nestedResultValue' };
var _scalarResult = { value: 'DOUBLE' };
var _searchProjectsRequest = { search: '_cursorSearch' };
var _searchProjectsResponse = {
    projects: '_project',
    aggregationData: '_aggregationData',
};
var _timeline = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
var _updateBrandkitRequest = {};
var _updateBrandkitResponse = { project: '_project' };
var _updateExtendedFieldsRequest = {};
var _updateExtendedFieldsResponse = { project: '_project' };
var _updatePhotoThemeRequest = {};
var _updatePhotoThemeResponse = { project: '_project' };
var _updateProjectRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    project: '_project',
};
var _updateProjectResponse = { project: '_project' };
var _updateStatusRequest = {};
var _updateStatusResponse = { project: '_project' };
var _updateStyleRequest = {};
var _updateStyleResponse = { project: '_project' };
var _uploadBriefFileRequest = { briefFile: 'BYTES' };
var _uploadBriefFileResponse = {};
function resolveWixEnterpriseProjectV1ProjectServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/project',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/project',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/project',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/project',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/project',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/project',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/project',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/project',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a Project.
 * The request body must include lorem and business address. Ipsum is optional.
 */
export function createProject(payload) {
    var _a = serializer(_createProjectRequest, { _project: _project, _timeline: _timeline }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createProjectResponse, {
        _project: _project,
        _timeline: _timeline,
    }).fromJSON;
    function __createProject(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'POST',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.CreateProject',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createProject.fromReq = fromReq;
    __createProject.__isAmbassador = true;
    return __createProject;
}
/** Retrieves a Project. */
export function getProject(payload) {
    var _a = serializer(_getProjectRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getProjectResponse, {
        _project: _project,
        _timeline: _timeline,
    }).fromJSON;
    function __getProject(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'GET',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.GetProject',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/{projectId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getProject.fromReq = fromReq;
    __getProject.__isAmbassador = true;
    return __getProject;
}
/** Retrieves a project brief. */
export function getBrief(payload) {
    var _a = serializer(_getBriefRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBriefResponse, {}).fromJSON;
    function __getBrief(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'GET',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.GetBrief',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/{projectId}/brief',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getBrief.fromReq = fromReq;
    __getBrief.__isAmbassador = true;
    return __getBrief;
}
/**
 * Updates a Project.
 *
 *
 * Each time the Project is updated,
 * `revision` increments by 1.
 * The current `revision` must be passed when updating the Project.
 * This ensures you're working with the latest Project
 * and prevents unintended overwrites.
 *
 * This endpoint support no revision flow, specifically for AI-Assistant
 * If UpdateProjectRequest.project.revision is not provided, We will overload the provision from the DB.
 */
export function updateProject(payload) {
    var _a = serializer(_updateProjectRequest, { _project: _project, _timeline: _timeline }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateProjectResponse, {
        _project: _project,
        _timeline: _timeline,
    }).fromJSON;
    function __updateProject(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'PATCH',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.UpdateProject',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/{project.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateProject.fromReq = fromReq;
    __updateProject.__isAmbassador = true;
    return __updateProject;
}
/**
 * Deletes a Project.
 * Deleting a Project permanently removes them from the Project List.
 */
export function deleteProject(payload) {
    var _a = serializer(_deleteProjectRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteProjectResponse, {}).fromJSON;
    function __deleteProject(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'DELETE',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.DeleteProject',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/{projectId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteProject.fromReq = fromReq;
    __deleteProject.__isAmbassador = true;
    return __deleteProject;
}
/**
 * Retrieves a list of Projects, given the provided [paging, filtering, and sorting][1].
 * Up to 1,000 Projects can be returned per request.
 */
export function queryProjects(payload) {
    var _a = serializer(_queryProjectsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryProjectsResponse, {
        _project: _project,
        _timeline: _timeline,
    }).fromJSON;
    function __queryProjects(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'GET',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.QueryProjects',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/query',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'POST',
                    url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                        protoPath: '/v1/projects/query',
                        data: serializedData,
                        host: host,
                    }),
                    data: serializedData,
                },
            ],
        };
        return metadata;
    }
    __queryProjects.fromReq = fromReq;
    __queryProjects.__isAmbassador = true;
    return __queryProjects;
}
/** Search for Projects by a given query. */
export function searchProjects(payload) {
    var _a = serializer(_searchProjectsRequest, {
        _aggregation: _aggregation,
        _cursorSearch: _cursorSearch,
        _nestedAggregation: _nestedAggregation,
        _nestedAggregationItem: _nestedAggregationItem,
        _rangeAggregation: _rangeAggregation,
        _rangeBucket: _rangeBucket,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchProjectsResponse, {
        _aggregationData: _aggregationData,
        _aggregationResults: _aggregationResults,
        _aggregationResultsScalarResult: _aggregationResultsScalarResult,
        _groupByValueResults: _groupByValueResults,
        _nestedAggregationResults: _nestedAggregationResults,
        _nestedResultValue: _nestedResultValue,
        _nestedResults: _nestedResults,
        _nestedValueAggregationResult: _nestedValueAggregationResult,
        _project: _project,
        _rangeAggregationResult: _rangeAggregationResult,
        _rangeResult: _rangeResult,
        _rangeResults: _rangeResults,
        _results: _results,
        _scalarResult: _scalarResult,
        _timeline: _timeline,
    }).fromJSON;
    function __searchProjects(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'GET',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.SearchProjects',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/search',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'POST',
                    url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                        protoPath: '/v1/projects/search',
                        data: serializedData,
                        host: host,
                    }),
                    data: serializedData,
                },
            ],
        };
        return metadata;
    }
    __searchProjects.fromReq = fromReq;
    __searchProjects.__isAmbassador = true;
    return __searchProjects;
}
/** Updates extended fields of a Project without incrementing revision */
export function updateExtendedFields(payload) {
    var _a = serializer(_updateExtendedFieldsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateExtendedFieldsResponse, {
        _project: _project,
        _timeline: _timeline,
    }).fromJSON;
    function __updateExtendedFields(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'POST',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.UpdateExtendedFields',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/{id}/update-extended-fields',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateExtendedFields.fromReq = fromReq;
    __updateExtendedFields.__isAmbassador = true;
    return __updateExtendedFields;
}
/** Create multiple Projects in a single request. Works synchronously. */
export function bulkCreateProjects(payload) {
    var _a = serializer(_bulkCreateProjectsRequest, { _project: _project, _timeline: _timeline }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateProjectsResponse, {
        _bulkProjectResult: _bulkProjectResult,
        _project: _project,
        _timeline: _timeline,
    }).fromJSON;
    function __bulkCreateProjects(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'POST',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.BulkCreateProjects',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/bulk/projects/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateProjects.fromReq = fromReq;
    __bulkCreateProjects.__isAmbassador = true;
    return __bulkCreateProjects;
}
/** Update multiple Projects in a single request. Works synchronously. */
export function bulkUpdateProjects(payload) {
    var _a = serializer(_bulkUpdateProjectsRequest, { _maskedProject: _maskedProject, _project: _project, _timeline: _timeline }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateProjectsResponse, {
        _bulkUpdateProjectsResponseBulkProjectResult: _bulkUpdateProjectsResponseBulkProjectResult,
        _project: _project,
        _timeline: _timeline,
    }).fromJSON;
    function __bulkUpdateProjects(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'POST',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.BulkUpdateProjects',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/bulk/projects/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateProjects.fromReq = fromReq;
    __bulkUpdateProjects.__isAmbassador = true;
    return __bulkUpdateProjects;
}
/** Delete multiple Projects in a single request. Works synchronously. */
export function bulkDeleteProjects(payload) {
    var _a = serializer(_bulkDeleteProjectsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteProjectsResponse, {}).fromJSON;
    function __bulkDeleteProjects(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'POST',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.BulkDeleteProjects',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/bulk/projects/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteProjects.fromReq = fromReq;
    __bulkDeleteProjects.__isAmbassador = true;
    return __bulkDeleteProjects;
}
/**
 * Synchronously update tags on multiple products, by list of product ids
 * A tag that appears both in the list of assign and unassign tags, will be assigned
 */
export function bulkUpdateProjectTags(payload) {
    var _a = serializer(_bulkUpdateProjectTagsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateProjectTagsResponse, {}).fromJSON;
    function __bulkUpdateProjectTags(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'POST',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.BulkUpdateProjectTags',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/bulk/products/update-tags',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateProjectTags.fromReq = fromReq;
    __bulkUpdateProjectTags.__isAmbassador = true;
    return __bulkUpdateProjectTags;
}
/**
 * Asynchronously update tags on multiple products, by provided filter
 * An empty filter will update all products
 * A tag that appears both in the list of assign and unassign tags, will be assigned
 */
export function bulkUpdateProjectTagsByFilter(payload) {
    var _a = serializer(_bulkUpdateProjectTagsByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateProjectTagsByFilterResponse, {}).fromJSON;
    function __bulkUpdateProjectTagsByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'POST',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.BulkUpdateProjectTagsByFilter',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/bulk/products/update-tags-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateProjectTagsByFilter.fromReq = fromReq;
    __bulkUpdateProjectTagsByFilter.__isAmbassador = true;
    return __bulkUpdateProjectTagsByFilter;
}
/** Extracts brief data from a brief file */
export function createProjectFromBrief(payload) {
    var _a = serializer(_createProjectFromBriefRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createProjectFromBriefResponse, {
        _project: _project,
        _timeline: _timeline,
    }).fromJSON;
    function __createProjectFromBrief(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'POST',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.CreateProjectFromBrief',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/create-from-brief',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createProjectFromBrief.fromReq = fromReq;
    __createProjectFromBrief.__isAmbassador = true;
    return __createProjectFromBrief;
}
/** Creates a project from scratch */
export function createProjectFromScratch(payload) {
    var _a = serializer(_createProjectFromScratchRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createProjectFromScratchResponse, {
        _project: _project,
        _timeline: _timeline,
    }).fromJSON;
    function __createProjectFromScratch(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'POST',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.CreateProjectFromScratch',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/create-from-scratch',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createProjectFromScratch.fromReq = fromReq;
    __createProjectFromScratch.__isAmbassador = true;
    return __createProjectFromScratch;
}
/** Updates the brandkit */
export function updateBrandkit(payload) {
    var _a = serializer(_updateBrandkitRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBrandkitResponse, {
        _project: _project,
        _timeline: _timeline,
    }).fromJSON;
    function __updateBrandkit(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'POST',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.UpdateBrandkit',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/{projectId}/brandkit',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBrandkit.fromReq = fromReq;
    __updateBrandkit.__isAmbassador = true;
    return __updateBrandkit;
}
/** Updates the ContentGenerationInfo */
export function updatePhotoTheme(payload) {
    var _a = serializer(_updatePhotoThemeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updatePhotoThemeResponse, {
        _project: _project,
        _timeline: _timeline,
    }).fromJSON;
    function __updatePhotoTheme(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'PUT',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.UpdatePhotoTheme',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/{projectId}/photo-theme',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updatePhotoTheme.fromReq = fromReq;
    __updatePhotoTheme.__isAmbassador = true;
    return __updatePhotoTheme;
}
/** Updates Project's Status */
export function updateStatus(payload) {
    var _a = serializer(_updateStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateStatusResponse, {
        _project: _project,
        _timeline: _timeline,
    }).fromJSON;
    function __updateStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'POST',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.UpdateStatus',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/{projectId}/status',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateStatus.fromReq = fromReq;
    __updateStatus.__isAmbassador = true;
    return __updateStatus;
}
/** Updates Project's Style */
export function updateStyle(payload) {
    var _a = serializer(_updateStyleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateStyleResponse, {
        _project: _project,
        _timeline: _timeline,
    }).fromJSON;
    function __updateStyle(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'POST',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.UpdateStyle',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/{projectId}/style',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateStyle.fromReq = fromReq;
    __updateStyle.__isAmbassador = true;
    return __updateStyle;
}
/** List all apps in a project */
export function listAllAppsInProject(payload) {
    var _a = serializer(_listAllAppsInProjectRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAllAppsInProjectResponse, {}).fromJSON;
    function __listAllAppsInProject(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'GET',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.ListAllAppsInProject',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/{projectId}/apps',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAllAppsInProject.fromReq = fromReq;
    __listAllAppsInProject.__isAmbassador = true;
    return __listAllAppsInProject;
}
/** Get Recommended Assets Types */
export function getRecommendedAssetTypes(payload) {
    var _a = serializer(_getRecommendedAssetTypesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRecommendedAssetTypesResponse, {}).fromJSON;
    function __getRecommendedAssetTypes(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'GET',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.GetRecommendedAssetTypes',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/{projectId}/recommended-asset-types',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRecommendedAssetTypes.fromReq = fromReq;
    __getRecommendedAssetTypes.__isAmbassador = true;
    return __getRecommendedAssetTypes;
}
/** Extract Project from Brief */
export function extractProjectFromBrief(payload) {
    var _a = serializer(_extractProjectFromBriefRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_extractProjectFromBriefResponse, {
        _project: _project,
        _timeline: _timeline,
    }).fromJSON;
    function __extractProjectFromBrief(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'POST',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.ExtractProjectFromBrief',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/extract-project-from-brief',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __extractProjectFromBrief.fromReq = fromReq;
    __extractProjectFromBrief.__isAmbassador = true;
    return __extractProjectFromBrief;
}
/** E2E project generation include project creation, assets generation and brandkit generation */
export function generateProjectAndAssets(payload) {
    var _a = serializer(_generateProjectAndAssetsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_generateProjectAndAssetsResponse, {
        _project: _project,
        _timeline: _timeline,
    }).fromJSON;
    function __generateProjectAndAssets(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'POST',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.GenerateProjectAndAssets',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/generate-project-and-assets',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __generateProjectAndAssets.fromReq = fromReq;
    __generateProjectAndAssets.__isAmbassador = true;
    return __generateProjectAndAssets;
}
/** Upload brief file only */
export function uploadBriefFile(payload) {
    var _a = serializer(_uploadBriefFileRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_uploadBriefFileResponse, {}).fromJSON;
    function __uploadBriefFile(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'POST',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.UploadBriefFile',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/upload-brief-file',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __uploadBriefFile.fromReq = fromReq;
    __uploadBriefFile.__isAmbassador = true;
    return __uploadBriefFile;
}
/** Get Automations installed on Project's sites */
export function getAutomations(payload) {
    var _a = serializer(_getAutomationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAutomationsResponse, {}).fromJSON;
    function __getAutomations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'GET',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.GetAutomations',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/{projectId}/automations',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAutomations.fromReq = fromReq;
    __getAutomations.__isAmbassador = true;
    return __getAutomations;
}
/** Get Main URL of the project */
export function getMainUrl(payload) {
    var _a = serializer(_getMainUrlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMainUrlResponse, {}).fromJSON;
    function __getMainUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'GET',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.GetMainUrl',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/{projectId}/main-url',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMainUrl.fromReq = fromReq;
    __getMainUrl.__isAmbassador = true;
    return __getMainUrl;
}
/** Get Analytics for project */
export function getAnalytics(payload) {
    var _a = serializer(_getAnalyticsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAnalyticsResponse, {
        _analyticsItem: _analyticsItem,
        _analyticsValue: _analyticsValue,
    }).fromJSON;
    function __getAnalytics(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'GET',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.GetAnalytics',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/projects/{projectId}/analytics',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAnalytics.fromReq = fromReq;
    __getAnalytics.__isAmbassador = true;
    return __getAnalytics;
}
/** Get bulk analytics for projects */
export function bulkGetAnalytics(payload) {
    var _a = serializer(_bulkGetAnalyticsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkGetAnalyticsResponse, {
        _analyticsItem: _analyticsItem,
        _analyticsValue: _analyticsValue,
        _getAnalyticsResponse: _getAnalyticsResponse,
    }).fromJSON;
    function __bulkGetAnalytics(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.enterprise.project.v1.project',
            method: 'POST',
            methodFqn: 'wix.enterprise.project.v1.ProjectService.BulkGetAnalytics',
            url: resolveWixEnterpriseProjectV1ProjectServiceUrl({
                protoPath: '/v1/bulk/projects/analytics',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkGetAnalytics.fromReq = fromReq;
    __bulkGetAnalytics.__isAmbassador = true;
    return __bulkGetAnalytics;
}
//# sourceMappingURL=http.impl.js.map